import Audio from "./Audio";
import Video from "./Video";
import Iframe from "./Iframe";

export default {
  Audio,
  Video,
  Iframe
};
